/**
 * Created by koppany.kiss on 2017. 08. 02..
 */

module.exports = function (app) {
	app.directive('selectOnBlur', function () {
		return {
			require: 'uiSelect',
			link: function (scope, element, attrs, ctrl) {
				element.on('blur', 'input.ui-select-search', function (event) {
					if (ctrl.open && (ctrl.tagging.isActivated || ctrl.activeIndex >= 0) && event.target.value && event.target.value != '') {
						var decision = false;

						for (var i = 0; i < ctrl.items.length; i++) {
							if (ctrl.items[i] == event.target.value) {
								decision = true;
							}
						}
						if (!decision) {
							var newItem;

							if (attrs.selectOnBlur == 'object') {
								newItem = {name: event.target.value};
							} else {
								newItem = event.target.value;
							}

							ctrl.items.unshift(newItem);
							ctrl.selected = ctrl.items[0];
						}

					}
					event.target.value = '';
				});
			}
		};
	});
};
